export interface BasketDiscountProduct {
  productID: number;
  price: number;
}

const basketDiscountProductFromResponse = (
  responseData: any,
): BasketDiscountProduct => ({
  productID: responseData.product_id,
  price: responseData.price / 100,
});

const basketDiscountToUpsertRequest = (discount: BasketDiscountProduct) => ({
  product_id: discount.productID,
  price: Math.round(discount.price * 100),
});

export interface BasketDiscountMetadata {
  products: BasketDiscountProduct[];
}

export const getEmptyBasketDiscountMetadata = (): BasketDiscountMetadata => ({
  products: [],
});

export const basketDiscountMetadataFromResponse = (
  responseData: any,
): BasketDiscountMetadata => ({
  products: (responseData.products ?? []).map(
    basketDiscountProductFromResponse,
  ),
});

export const basketDiscountMetadataToUpsertRequest = (
  metadata: BasketDiscountMetadata,
) => ({
  products: metadata.products.map(basketDiscountToUpsertRequest),
});
